/* eslint-disable ember/no-computed-properties-in-native-classes */
import EmberObject, { computed } from '@ember/object';

import * as ArrayUtils from '../../utils/array';
import * as NoiseUtils from '../../utils/noise';
import * as CommonUtils from '../../../utils/common';
import * as ResultsUtils from '../../utils/results';

export default class NoiseResult extends EmberObject {
  frequencyArray;
  noiseFrequencyArray;
  noiseGroup;
  adcBandwidth;
  nominalNoiseArray;
  minimumNoiseArray;
  maximumNoiseArray;

  @computed('nominalNoiseArray', 'noiseFrequencyArray', 'adcBandwidth') get _nominalRmsValue() {
    var nominalNoiseArray = this.nominalNoiseArray;
    var noiseFrequencyArray = this.noiseFrequencyArray;
    var adcBandwidth = this.adcBandwidth;
    var result = NoiseUtils.getRmsNoise(nominalNoiseArray, adcBandwidth, noiseFrequencyArray);
    return result;
  }

  @computed('maximumNoiseArray', 'noiseFrequencyArray', 'adcBandwidth') get _worstCaseRmsValue() {
    var maximumNoiseArray = this.maximumNoiseArray;
    var noiseFrequencyArray = this.noiseFrequencyArray;
    var adcBandwidth = this.adcBandwidth;

    if (CommonUtils.isNullOrUndefined(maximumNoiseArray)) {
      return null;
    }

    var result = NoiseUtils.getRmsNoise(maximumNoiseArray, adcBandwidth, noiseFrequencyArray);
    return result;
  }

  @computed('_nominalRmsValue') get _nominalPeakToPeak() {
    var _nominalRmsValue = this._nominalRmsValue;
    var result = NoiseUtils.getPeakToPeak(_nominalRmsValue);
    return result;
  }

  @computed('_worstCaseRmsValue') get _worstCasePeakToPeak() {
    var _worstCaseRmsValue = this._worstCaseRmsValue;

    if (CommonUtils.isNullOrUndefined(_worstCaseRmsValue)) {
      return null;
    }

    var result = NoiseUtils.getPeakToPeak(_worstCaseRmsValue);
    return result;
  }

  @computed('frequencyArray', 'nominalNoiseArray', 'minimumNoiseArray', 'maximumNoiseArray') get graphData() {
    var frequencyArray = this.frequencyArray;
    var nominalNoiseArray = this.nominalNoiseArray;
    var minimumNoiseArray = this.minimumNoiseArray;
    var maximumNoiseArray = this.maximumNoiseArray;
    var dataPoints = ArrayUtils.joinArrays(frequencyArray, nominalNoiseArray);

    if (!CommonUtils.isNullOrUndefined(minimumNoiseArray) && !CommonUtils.isNullOrUndefined(maximumNoiseArray)) {
      dataPoints = ArrayUtils.joinToleranceArrays(
        frequencyArray,
        nominalNoiseArray,
        minimumNoiseArray,
        maximumNoiseArray,
      );
    }

    var limits = ResultsUtils.getRangeLimits(dataPoints);
    var result = { data: dataPoints, limits: limits };
    return result;
  }

  @computed('_nominalRmsValue', '_worstCaseRmsValue') get rms() {
    var _nominalRmsValue = this._nominalRmsValue;
    var _worstCaseRmsValue = this._worstCaseRmsValue;
    var result = { nominalValue: _nominalRmsValue, worstCaseValue: _worstCaseRmsValue };
    return result;
  }

  @computed('_nominalPeakToPeak', '_worstCasePeakToPeak') get peakToPeakNoise() {
    var _nominalPeakToPeak = this._nominalPeakToPeak;
    var _worstCasePeakToPeak = this._worstCasePeakToPeak;
    var result = { nominalValue: _nominalPeakToPeak, worstCaseValue: _worstCasePeakToPeak };
    return result;
  }

  @computed('_nominalRmsValue', '_worstCaseRmsValue') get adcTableData() {
    var _nominalRmsValue = this._nominalRmsValue;
    var _worstCaseRmsValue = this._worstCaseRmsValue;
    var nominalADCTableData = NoiseUtils.getSNRandENOB(_nominalRmsValue);
    var worstCaseADCTableData = NoiseUtils.getSNRandENOB(_worstCaseRmsValue);
    var result = nominalADCTableData.map((item, index) => {
      var worstCaseSNR = worstCaseADCTableData[index].snr;
      var worstCaseENOB = worstCaseADCTableData[index].enob;
      return {
        adc: item.adc,
        nominalSNR: item.snr,
        worstCaseSNR: worstCaseSNR,
        nominalENOB: item.enob,
        worstCaseENOB: worstCaseENOB,
      };
    });

    return result;
  }
}
